// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { SequenceRunStatus } from "./sequence-run-status";
import {
  SequenceStepProgress,
  SequenceStepProgressT,
  verifySequenceStepProgress,
} from "./sequence-step-progress";
import { Uuid, UuidT, verifyUuid } from "./uuid";

/**
 * Progress of one channel-modifier sequence run.
 *
 * Carried on a `FrontEndMessage` whose `ack_outcome` is `SequenceProgress`.
 * Every report carries every step, so a reader that missed one report loses
 * nothing.
 */
export class SequenceProgress implements flatbuffers.IUnpackableObject<SequenceProgressT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SequenceProgress {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSequenceProgress(
    bb: flatbuffers.ByteBuffer,
    obj?: SequenceProgress,
  ): SequenceProgress {
    return (obj || new SequenceProgress()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSequenceProgress(
    bb: flatbuffers.ByteBuffer,
    obj?: SequenceProgress,
  ): SequenceProgress {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SequenceProgress()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Identifies the run; every report of the same run carries the same id.
   */
  runId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * The channel modifier whose program the run executes.
   */
  modifierId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  modifierName(): string | null;
  modifierName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  modifierName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  status(): SequenceRunStatus {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SequenceRunStatus.Running;
  }

  /**
   * Unix time in nanoseconds when the run started (VTS clock).
   */
  startedAt(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  /**
   * Milliseconds since the run started (VTS monotonic clock).
   */
  elapsedMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Every step in program order, with its current state.
   */
  steps(index: number, obj?: SequenceStepProgress): SequenceStepProgress | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new SequenceStepProgress()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  stepsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Why the run failed, was withheld, released after a failure, or skipped;
   * empty otherwise.
   */
  detail(): string | null;
  detail(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  detail(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * How many commands share this run's floor lease; 1 when none joined it.
   */
  leaseHolders(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  static startSequenceProgress(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addRunId(builder: flatbuffers.Builder, runIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, runIdOffset, 0);
  }

  static addModifierId(builder: flatbuffers.Builder, modifierIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, modifierIdOffset, 0);
  }

  static addModifierName(builder: flatbuffers.Builder, modifierNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, modifierNameOffset, 0);
  }

  static addStatus(builder: flatbuffers.Builder, status: SequenceRunStatus) {
    builder.addFieldInt8(3, status, SequenceRunStatus.Running);
  }

  static addStartedAt(builder: flatbuffers.Builder, startedAt: bigint) {
    builder.addFieldInt64(4, startedAt, 0n);
  }

  static addElapsedMs(builder: flatbuffers.Builder, elapsedMs: number) {
    builder.addFieldInt32(5, elapsedMs, 0);
  }

  static addSteps(builder: flatbuffers.Builder, stepsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, stepsOffset, 0);
  }

  static createStepsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startStepsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addDetail(builder: flatbuffers.Builder, detailOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, detailOffset, 0);
  }

  static addLeaseHolders(builder: flatbuffers.Builder, leaseHolders: number) {
    builder.addFieldInt16(8, leaseHolders, 0);
  }

  static endSequenceProgress(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // run_id
    builder.requiredField(offset, 6); // modifier_id
    return offset;
  }

  unpack(): SequenceProgressT {
    return new SequenceProgressT(
      this.runId() !== null ? this.runId()!.unpack() : null,
      this.modifierId() !== null ? this.modifierId()!.unpack() : null,
      this.modifierName(),
      this.status(),
      this.startedAt(),
      this.elapsedMs(),
      this.bb!.createObjList<SequenceStepProgress, SequenceStepProgressT>(
        this.steps.bind(this),
        this.stepsLength(),
      ),
      this.detail(),
      this.leaseHolders(),
    );
  }

  unpackTo(_o: SequenceProgressT): void {
    _o.runId = this.runId() !== null ? this.runId()!.unpack() : null;
    _o.modifierId = this.modifierId() !== null ? this.modifierId()!.unpack() : null;
    _o.modifierName = this.modifierName();
    _o.status = this.status();
    _o.startedAt = this.startedAt();
    _o.elapsedMs = this.elapsedMs();
    _o.steps = this.bb!.createObjList<SequenceStepProgress, SequenceStepProgressT>(
      this.steps.bind(this),
      this.stepsLength(),
    );
    _o.detail = this.detail();
    _o.leaseHolders = this.leaseHolders();
  }

  unpackFields(...fields: string[]): SequenceProgressT {
    const t = new SequenceProgressT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("run_id")) {
      t.runId = this.runId() !== null ? this.runId()!.unpack() : null;
    }
    if (fieldSet.has("modifier_id")) {
      t.modifierId = this.modifierId() !== null ? this.modifierId()!.unpack() : null;
    }
    if (fieldSet.has("modifier_name")) {
      t.modifierName = this.modifierName();
    }
    if (fieldSet.has("status")) {
      t.status = this.status();
    }
    if (fieldSet.has("started_at")) {
      t.startedAt = this.startedAt();
    }
    if (fieldSet.has("elapsed_ms")) {
      t.elapsedMs = this.elapsedMs();
    }
    if (fieldSet.has("steps")) {
      t.steps = this.bb!.createObjList<SequenceStepProgress, SequenceStepProgressT>(
        this.steps.bind(this),
        this.stepsLength(),
      );
    }
    if (fieldSet.has("detail")) {
      t.detail = this.detail();
    }
    if (fieldSet.has("lease_holders")) {
      t.leaseHolders = this.leaseHolders();
    }
    return t;
  }
}

export class SequenceProgressT implements flatbuffers.IGeneratedObject {
  constructor(
    public runId: UuidT | null = null,
    public modifierId: UuidT | null = null,
    public modifierName: string | Uint8Array | null = null,
    public status: SequenceRunStatus = SequenceRunStatus.Running,
    public startedAt: bigint = 0n,
    public elapsedMs: number = 0,
    public steps: SequenceStepProgressT[] = [],
    public detail: string | Uint8Array | null = null,
    public leaseHolders: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.runId === null || this.runId === undefined) {
      throw new Error('Required field "run_id" is not set');
    }
    if (this.modifierId === null || this.modifierId === undefined) {
      throw new Error('Required field "modifier_id" is not set');
    }
    const runId = this.runId !== null ? this.runId!.pack(builder) : 0;
    const modifierId = this.modifierId !== null ? this.modifierId!.pack(builder) : 0;
    const modifierName = this.modifierName !== null ? builder.createString(this.modifierName!) : 0;
    const steps = SequenceProgress.createStepsVector(
      builder,
      builder.createObjectOffsetList(this.steps),
    );
    const detail = this.detail !== null ? builder.createString(this.detail!) : 0;

    SequenceProgress.startSequenceProgress(builder);
    SequenceProgress.addRunId(builder, runId);
    SequenceProgress.addModifierId(builder, modifierId);
    SequenceProgress.addModifierName(builder, modifierName);
    SequenceProgress.addStatus(builder, this.status);
    SequenceProgress.addStartedAt(builder, this.startedAt);
    SequenceProgress.addElapsedMs(builder, this.elapsedMs);
    SequenceProgress.addSteps(builder, steps);
    SequenceProgress.addDetail(builder, detail);
    SequenceProgress.addLeaseHolders(builder, this.leaseHolders);

    return SequenceProgress.endSequenceProgress(builder);
  }

  clone(): SequenceProgressT {
    const obj = new SequenceProgressT();
    obj.runId = this.runId !== null ? this.runId!.clone() : null;
    obj.modifierId = this.modifierId !== null ? this.modifierId!.clone() : null;
    obj.modifierName = this.modifierName;
    obj.status = this.status;
    obj.startedAt = this.startedAt;
    obj.elapsedMs = this.elapsedMs;
    obj.steps = this.steps.map((e) => e.clone());
    obj.detail = this.detail;
    obj.leaseHolders = this.leaseHolders;
    return obj;
  }

  equals(other: SequenceProgressT): boolean {
    if (this.runId !== null && other.runId !== null) {
      if (!this.runId!.equals(other.runId!)) return false;
    } else if (this.runId !== other.runId) return false;
    if (this.modifierId !== null && other.modifierId !== null) {
      if (!this.modifierId!.equals(other.modifierId!)) return false;
    } else if (this.modifierId !== other.modifierId) return false;
    if (this.modifierName !== other.modifierName) return false;
    if (this.status !== other.status) return false;
    if (this.startedAt !== other.startedAt) return false;
    if (this.elapsedMs !== other.elapsedMs) return false;
    if (this.steps.length !== other.steps.length) return false;
    for (let i = 0; i < this.steps.length; i++) {
      const a = this.steps[i];
      const b = other.steps[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.detail !== other.detail) return false;
    if (this.leaseHolders !== other.leaseHolders) return false;
    return true;
  }
}

export function verifySequenceProgress(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "run_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "modifier_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 8);
    verifier.checkScalarField(tablePos, 14, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySequenceStepProgress);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 20, 2);
  } finally {
    verifier.popDepth();
  }
}
